// extracted by mini-css-extract-plugin
export var container = "lpCompetitorReviewBadges-module--container--43197";
export var heading = "lpCompetitorReviewBadges-module--heading--21d8e";
export var subheading = "lpCompetitorReviewBadges-module--subheading--93720";